import firebase from 'firebase';
import dayjs from 'dayjs';
import 'dayjs/locale/nb';
dayjs.locale('nb');

export const getDay = (date) => dayjs(date).format('YYYY-MM-DD');
export const getTime = (date) => dayjs(date).format('HH:mm');
export const formatShortDate = (date) => dayjs(date).format('DD.MM.YY');
export const formatDate = (date) => dayjs(date).format('DD.MM.YY-HH:mm');

export const isAfter = (datefrom, dateTo) => dayjs(datefrom).isAfter(dateTo);

export const isToday = (date) => dayjs().isSame(dayjs(date), 'day');

export const getTimeBefore = (date, number = 1, unit = 'hours') => {
  return dayjs(date).subtract(number, unit);
};

export const fromDateToTimeStamp = (date) => {
  return firebase.firestore.Timestamp.fromDate(date);
};
